// Browser-side CSV generation + download helpers.

type Cell = string | number | boolean | null | undefined;

function escape(v: Cell): string {
  if (v == null) return '';
  const s = String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Build a CSV string from headers + rows. Leads with a UTF-8 BOM so Excel
 *  renders accented names/messages correctly; CRLF line endings for Excel. */
export function toCsv(headers: string[], rows: Cell[][]): string {
  const lines = [headers.map(escape).join(',')];
  for (const row of rows) lines.push(row.map(escape).join(','));
  return '﻿' + lines.join('\r\n');
}

/** Trigger a client-side download of the given CSV text. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
